import React from "react";
import Select from "react-select";
import {
    BITACORA_FLETE_AJENO,
    BITACORA_FLETE_PROPIO,
} from "../../../../../../utility/constants";

const OPCIONES_FLETE = [
    { value: "", label: "Todos" },
    { value: BITACORA_FLETE_AJENO, label: "Ajeno" },
    { value: BITACORA_FLETE_PROPIO, label: "Propio" },
];

export const FiltroFlete = ({ bitacora }) => {
    const opcionSeleccionada = OPCIONES_FLETE.find(
        (opcion) => opcion.value === bitacora.ambitoFlete,
    );

    return (
        <div className="bitacora-fletes__filtros mb-3">
            <div className="bitacora-fletes__filtro">
                <label htmlFor="ambito_flete" className="mb-0 pl-0">
                    Flete
                </label>
                <div className="bitacora-fletes__filtro-select">
                    <Select
                        inputId="ambito_flete"
                        className="react-select-container"
                        backspaceRemovesValue={false}
                        isSearchable
                        options={OPCIONES_FLETE}
                        value={opcionSeleccionada}
                        onChange={(opcion) =>
                            bitacora.cambiarAmbitoFlete(opcion.value)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                    />
                </div>
            </div>
        </div>
    );
};
